<div class="corner-ribbon bg-danger d-none d-md-block">
  <span>Visit at {{this.visitContext.savedVisit.updated | timestamp}}</span>
</div>
